<template>
      <Card>
        <div class="row">
          <div class="col-md-4">
            <custom-input label="نوع" type="select"
                          placeholder="انتخاب نوع..."
                          select-label="title"
                          v-model="info.type"
                          :select-options="[{title : 'فروشنده',id:'seller'},{title : 'خریدار',id:'buyer'}]"></custom-input>
          </div>
          <div class="col-md-4">
            <custom-input label="وضعیت" type="select"
                          placeholder="انتخاب وضعیت..."
                          select-label="title"
                          v-model="info.is_enabled"
                          :select-options="[{title : 'فعال',id:'1'},{title : 'غیرفعال',id:'0'}]"></custom-input>
          </div>
        </div>
        <LocalDataTable :functions="functions" :init-document="is_mounted" v-if="showTable" :ajax-link="ajaxLink" :columns="columns"></LocalDataTable>
      </Card>
</template>

<script>
import MasterLayout from "@/components/MasterLayout";
import Card from "@/components/forms/Card";
import LocalDataTable from "@/components/LocalDataTable";
import CustomInput from "@/components/CustomInput";
import {mapActions} from "vuex";
import Swal from 'sweetalert2';
import {AppApi} from "@/api/AppApi";
import {showSystemNoti} from "@/shared/helper";
let mounted = false;
export default {
  name: "PlanList",
  components: {CustomInput, LocalDataTable, Card, MasterLayout},
  data(){
    return{
      functions:[
        {name: 'delPlan',method : this.delPlan}
      ],
      is_mounted : mounted,
      ajaxLink : 'admin/Plan/list?t=1',
      showTable : true,
      info:{type : '',is_enabled : ''},
      columns:[
        {title :'عنوان'},{title : 'مرتبط با'},{title :'وضعیت'},
        {title : 'اولویت'}
        ,{title : '<i class="far fa-cogs"></i>',sortable : false}
      ]
    }
  },
  methods:{
    ...mapActions('app',{
      setPageTitle:'setPageTitle',
      setPageLoading:'setPageLoading',
      setShowHead : 'setShowHead'
    }),
    async delPlan(id,element)
    {
      Swal.fire({
        title: 'آیا مطمئن هستید؟',
        text: "تمام اطلاعات مربوط به اشتراک حذف می شود.",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'تایید حذف!',
        cancelButtonText: 'کنسل',
      }).then(async (result) => {
        if (result.value) {
          const result = await AppApi.deletePlan(id);
          if (result.ok)
          {
            if (element)
              $(element).closest('tr').remove();
            showSystemNoti('success', result.message);
          }
          else
            showSystemNoti('danger',result.error);
        }
      })
    },
    changeAjaxLink()
    {
      let link = 'admin/Plan/list?t=1';
      const params =this.info;
      for (const key in params)
      {
        if (!params.hasOwnProperty(key))
          continue;
        if (params[key])
        {
          link += '&'+key+'='+params[key].id;
        }
      }
      this.ajaxLink = link;
    }
  },
  watch:{
    info : {
      handler(type)
      {
        this.changeAjaxLink();
        // if (type)
        // {
        //   this.ajaxLink = 'admin/Plan/list?type='+type.id;
        // }
        // else
        //   this.ajaxLink = 'admin/Plan/list';
      },deep : true
    }
  },
  async mounted()
  {
    this.setPageTitle('مدیریت اشتراک ها');
    this.setShowHead(true);
    this.is_mounted = mounted;
    mounted = true;
  }
}
</script>

<style scoped>

</style>